import React, { useEffect } from 'react';
import './Servicios.css';
import Footer from './Footer';



const MediaContent = ({ src, alt, type }) => {
  if (type === 'video') {
    return (
      <video 
        width="100%"
        height="100%"
        autoPlay
        muted
        playsinline
        preload="auto"
        loop
        style={{ objectFit: 'cover' }}
      >
        <source src={src} type="video/mp4" />
        <p>Tu navegador no soporta videos HTML5.</p>
      </video>
    );
  }
  return <img src={src} alt={alt} className="media-content" />;
};

const Servicios = () => {
  useEffect(() => {
    // Obtener el hash de la URL
    const hash = window.location.hash;
    if (hash) {
      // Remover el # del hash
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        // Esperar un momento para que los elementos se rendericen
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, []);

  return (
    <div className="servicios-page">
      <section id="implantologia" className="servicio-section">
        <div className="servicio-container">
          <div className="servicio-content">
            <div className="servicio-texto">
              <h2>IMPLANTOLOGÍA BUCOMAXILOFACIAL</h2>
              <h3>Restaurando Sonrisas con Precisión</h3>
              <p>
                La Implantología Bucomaxilofacial es la especialidad encargada de devolver funcionalidad y estética a la
                sonrisa a través de implantes dentales de alta precisión.
              </p>
              <button className="reserva-btn" style={{
                marginTop: '20px',
                marginBottom: '20px'
              }} onClick={() => {
                window.open('https://2626ba419c4acd951d700e987eb7403a951951b3.agenda.softwaredentalink.com/agenda?modalidad=1', '_blank')
              }}>RESERVA TU HORA</button>
              <p>
                Hoy los implantes dentales son la mejor alternativa para recuperar su sonrisa en Antofagasta.
              </p>
              <p>
                Implantes dentales provenientes de Estados Unidos, calidad y precisión
                en tus resultados.
              </p>
            </div>
            <div className="servicio-imagenes">
              <div className="media-container">
                <img src='/assets/images/cirugia-guiada.gif' alt="Implante dental 1" />
              </div>
              <div className="media-container">
                <img src='/assets/images/implante2.gif' alt="Implante dental 2" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="rehabilitacion" className="servicio-section">
        <div className="servicio-container">
          <div className="servicio-content">
            <div className="servicio-texto">
              <h2>REHABILITACIÓN ORAL</h2>
              <h3>Recuperando confianza, una sonrisa a la vez</h3>
              <p>
              La Rehabilitación Oral es clave para devolver la funcionalidad y estética a la sonrisa cuando hay pérdida de piezas dentales. A través de un enfoque integral, esta especialidad 
              permite mejorar la armonía de la sonrisa mediante implantes dentales y coronas ceramicas, contribuyendo al bienestar general del paciente
              </p>
              <p>
              Nuestro objetivo es brindar una sonrisa saludable y funcional, mejorando su
              calidad de vida con resultados naturales y de larga duración.
              </p>
              <button className="reserva-btn" onClick={() => {
                window.open('https://2626ba419c4acd951d700e987eb7403a951951b3.agenda.softwaredentalink.com/agenda?modalidad=1', '_blank')
              }}>RESERVA TU HORA</button>
            </div>
            <div className="servicio-imagenes">
              <div className="imagen-grid">
                <div className="imagen-item">
                  <img src='/assets/images/rehab/sonrisa-1.png' alt="Rehabilitación oral 1" />
                </div>
                <div className="imagen-item">
                  <img src='/assets/images/rehab/sonrisa-2.png' alt="Rehabilitación oral 2" />
                </div>
                <div className="imagen-item">
                  <img src='/assets/images/rehab/sonrisa-3.png' alt="Rehabilitación oral 3" />
                </div>
                <div className="imagen-item">
                  <img src='/assets/images/rehab/sonrisa-4.png' alt="Rehabilitación oral 4" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="diseno-sonrisa" className="servicio-section">
        <div className="servicio-container">
          <div className="servicio-content">
            <div className="servicio-texto">
              <h2>DISEÑO DE SONRISA DE ALTO NIVEL</h2>
              <h3>Tu mejor versión</h3>
              <p>
                El Diseño de Sonrisa Digital es una herrmienta en la cual mediante la planificacion computarizada de los dientes adecuados
                para cada paciente, utilizamos materiales vitrocerámicos, buscando
                restablecer una armonía general en base a parámetros estéticos personalizados.
              </p>
              <p>
                En CAIMA buscamos la mejor calidad y durabilidad en las sonrisas, por lo que no utilizamos resinas o composites.
              </p>
              <button className="reserva-btn" onClick={() => {
                window.open('https://2626ba419c4acd951d700e987eb7403a951951b3.agenda.softwaredentalink.com/agenda?modalidad=1', '_blank')
              }}>RESERVA TU HORA</button>
            </div>
            <div className="servicio-imagenes">
              <div className="media-container">
                <img src='/assets/images/sonrisa1.gif' alt="Diseño de sonrisa 1" />
              </div>
              <div className="media-container">
                <img src='/assets/images/sonrisa2.gif' alt="Diseño de sonrisa 2" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Servicios; 